/** 3Jane sUSD3 cooldown surface. After `startCooldown(shares)` the
 *  position stays on the owner's balance (no escrow) and
 *  `getCooldownStatus(user)` reports the request: `cooldownEnd` is when
 *  the plain ERC-4626 `redeem` becomes possible, `windowEnd` is when
 *  the withdrawal window closes (read ~100 years out in practice — no
 *  real expiry), `shares` is the requested sUSD3 amount.
 *
 *  Verified getter (impl `0x529cbf11…`):
 *    `getCooldownStatus(address) → (uint256 cooldownEnd, uint256 windowEnd, uint256 shares)` */
export const Susd3CooldownStatusAbi = [
  {
    name: 'getCooldownStatus',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [
      { type: 'uint256', name: 'cooldownEnd' },
      { type: 'uint256', name: 'windowEnd' },
      { type: 'uint256', name: 'shares' },
    ],
  },
  {
    name: 'convertToAssets',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shares' }],
    outputs: [{ type: 'uint256', name: 'assets' }],
  },
] as const
